import {Routes} from '@angular/router';
import {HomeComponent} from "./pages/home/home.component";
import {isUserAuthenticated} from "./services/guards/auth.guard";
import {IdentificationComponent} from "./pages/onboarding/identification/identification.component";

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: 'T-Crypto',
  },
  {
    path: 'how-it-work',
    title: 'T-Crypto - How it work?',
    loadComponent: () => import('./pages/how-it-work/how-it-work.component').then(m => m.HowItWorkComponent)
  },
  {
    path: 'about-us',
    title: 'T-Crypto - About us',
    loadComponent: () => import('./pages/about-us/about-us.component').then(m => m.AboutUsComponent)
  },
  {
    path: 'news',
    title: 'T-Crypto - News',
    loadChildren: () => import('./pages/news.routes').then(m => m.newsRoutes)
  },
  {
    path: 'faq',
    title: 'T-Crypto - FAQ',
    loadComponent: () => import('./pages/faq/faq.component').then(m => m.FaqComponent)
  },
  {
    path: 'components',
    loadComponent: () => import('./pages/components/components.component').then(m => m.ComponentsComponent)
  },
  {
    path: 'verify',
    title: 'T-Crypto - Verification',
    loadChildren: () => import('./verification/verification.routes').then(m => m.verificationRoutes),
    canActivate: [isUserAuthenticated]
  },
  {
    path: 'cabinet',
    loadChildren: () => import('./cabinet/cabinet.routes').then(m => m.cabinetRoutes),
    canActivate: [isUserAuthenticated]
  },
  {
    path: 'referral-cabinet',
    loadChildren: () => import('./referral/cabinet/referral-cabinet.routes').then(m => m.referralCabinetRoutes),
    canActivate: [isUserAuthenticated]
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/onboarding/identification/identification.component').then(m => m.IdentificationComponent),
  },
  {
    path: '**', redirectTo: () => {
      return ''
    }
  }
];
